/// <reference types="@capacitor/cli" />
export {};
